import SmartBanner from 'smart-app-banner';

function initializeSmartBanner() {
  new SmartBanner({
    daysHidden: 15,   // days to hide banner after close button is clicked (defaults to 15)
    daysReminder: 90, // days to hide banner after "VIEW" button is clicked (defaults to 90)
    appStoreLanguage: 'us', // language code for the App Store (defaults to user's browser language)
    title: 'SCCU Mobile',
    author: 'Space Coast Credit Union',
    button: 'VIEW',
    store: {
      ios: 'On the App Store',
      android: 'In Google Play'
    },
    price: {
      ios: 'FREE',
      android: 'FREE'
    }
    // , theme: '' // put platform type ('ios', 'android', etc.) here to force single theme on all device
    , icon: '/Frontend/dist/images/icons/icon-sccu-mobile-app-48.png' // full path to icon image if not using website icon image
    // , force: 'ios' // Uncomment for platform emulation
  });
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeSmartBanner()
})
